module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Black.c0b00efd.ttf";